import { render, staticRenderFns } from "./simulasi_penetapan_massal.vue?vue&type=template&id=71942f3b&"
import script from "./simulasi_penetapan_massal.vue?vue&type=script&lang=js&"
export * from "./simulasi_penetapan_massal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports